export const DEFAULT_THREADS_PAGE_SIZE = 10;
export const DEFAULT_MESSAGES_PAGE_SIZE = 10;

